import { Tooltip, TextField, IconButton, InputAdornment } from 'components/mui';
import { CloseOutlinedIcon, LocationIcon } from 'components/icons';
import { useFullAddressField } from 'containers/pages/contacts/hooks';
//import { MapDialog } from 'containers/pages/contacts/components';
import style from './fullAddress.module.css';
import { func, object, string } from 'prop-types';

/**
 * @component FullAddressField
 * @param {Object} props
 * @param {string} props.type
 * @param {string} props.value
 * @param {ContactInfo} props.contact
 * @param {function} props.dispatch
 * @returns {JSX.Element}
 */
function FullAddressField({ type, value, contact, dispatch }) {
	const { openMap, onReset, onOpenMap, onCloseMap } = useFullAddressField(type, contact, dispatch);

	return (
		<>
			<TextField
				label="Full Address"
				variant="outlined"
				value={value}
				InputLabelProps={{ shrink: true }}
				InputProps={
					({ readOnly: true },
					{
						endAdornment: (
							<>
								<Tooltip arrow title="View location">
									<IconButton className={style.icon_button} disableRipple onClick={onOpenMap}>
										<LocationIcon className={style.icon} color="primary" size="small" />
									</IconButton>
								</Tooltip>
								<InputAdornment position="end">
									<IconButton onClick={onReset}>
										<CloseOutlinedIcon id="fullAddress" fontSize="small" />
									</IconButton>
								</InputAdornment>
							</>
						),
					})
				}
			/>
			{/*<MapDialog open={openMap} contact={contact} type={type} onClose={onCloseMap} />*/}
		</>
	);
}

FullAddressField.propTypes = {
	type: string,
	value: string,
	contact: object,
	dispatch: func,
};

export default FullAddressField;
